// This file is auto-generated and contains a map with all design-tokens in @tdcerhverv/parrotfish
const colorsMap={
errorDark: '#921038',
error: '#be1450',
errorMediumLight: '#da1854',
errorLight: '#f8dfdf',
warningDark: '#c84600',
warning: '#ffcf42',
warningMediumLight: '#ffd966',
warningLight: '#fefaec',
infoDark: '#1a6c9e',
info: '#59b8eb',
infoMediumLight: '#7cc1e6',
infoLight: '#ecf5fb',
successDark: '#03675b',
success: '#1b998b',
successMediumLight: '#1cb8a5',
successLight: '#eaf4f2',
greyDarkest: '#3c3c3c',
greyDark: '#787878',
greyMediumDark: '#949698',
greyMedium: '#bdbebf',
greyMediumLight: '#e6e7e8',
greyLight: '#f1f2f3',
greyLightest: '#f9fafb',
black: '#1a1a1a',
white: '#ffffff',
accent: '#3ae5bb',
accentDark: '#30bf9b',
secondaryDark: '#e58d17',
secondary: '#ffbf1a',
primaryLight: '#233ced',
primary: '#0000bf',
primaryDark: '#000078',
brandOrange: '#ff6b36',
};
module.exports=colorsMap;
